<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    dark
    color="black"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-breakpoint="960"
    app
    width="240"
    mini-variant-width="80"
    v-bind="$attrs"
  >
    <v-list-item two-line>
      <a href="https://picknote.co/">
        <v-img
          src="@/assets/logo/short-white.svg"
          aspect-ratio="1"
          width="86px"
          height="33px"
          class="mt-2 ml-2"
          v-if="!expandOnHover"
        />
        <v-img
          src="@/assets/logo/icon-white.png"
          aspect-ratio="1"
          width="33px"
          height="33px"
          class="mt-2 ml-2"
          v-if="expandOnHover"
        />
      </a>
    </v-list-item>
    <v-divider />
    <v-list expand nav>
      <v-list-item>
        <v-list-item-icon>
          <v-icon v-text="userItem.icon" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="userItem.title" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider />
    <v-list expand nav>
      <template v-for="(item, i) in computedItems">
        <base-item :key="`item-${i}`" :item="item" />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Drawer',

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [
      {
        icon: 'mdi-view-dashboard',
        title: 'レポート',
        to: '/client/report'
      },
      {
        icon: 'mdi-calendar',
        title: 'スケジュール',
        to: '/client/schedule'
      },
      {
        icon: 'mdi-play-circle-outline',
        title: 'コンテンツ',
        to: '/client/contents'
      },
      {
        icon: 'mdi-chart-bubble',
        title: 'プレイリスト',
        to: '/client/playlist'
      },
      {
        icon: 'mdi-camera',
        title: '管理',
        to: '/client/devices'
      }
    ],
    adminItems: [
      {
        icon: 'mdi-fire',
        title: 'アドミン',
        to: '/client/admin'
      }
    ]
  }),

  computed: {
    ...mapGetters({
      user: 'users/getActiveUser',
      admin: 'users/getActiveAdmin',
      drawerControl: 'interfaceControls/getDrawer'
    }),
    drawer: {
      get() {
        return this.drawerControl
      },
      set(val) {
        this.setDrawer({ drawer: val })
      }
    },
    userItem() {
      return {
        icon: 'mdi-account-circle',
        title: this.user ? this.user.email : 'User not found'
      }
    },
    computedItems() {
      let drawerItems = this.items.map(this.mapItem)
      if (this.admin) {
        drawerItems = drawerItems.concat(this.adminItems.map(this.mapItem))
      }
      return drawerItems
    }
  },
  watch: {
    '$vuetify.breakpoint.smAndDown'(val) {
      this.$emit('update:expandOnHover', !val)
    }
  },
  methods: {
    ...mapActions({
      setDrawer: 'interfaceControls/setDrawer'
    }),
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: item.title
      }
    }
  }
}
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
